export const AUTH_TOKEN = 'id_token';
export const REFRESH_TOKEN = 'id_token_refresh';
//TODO: MOVE TO CONSTANTS PACKAGE
